import DownloadIcon from '@mui/icons-material/Download';
import { Button } from "@mui/material";
import { ICertificateData } from "../../entities/table";
import { downloadCertificates } from '../../lib/download';
interface IProps {
    certificates: ICertificateData[];
}

const excelHeader = [
    "Statut",
    "Prénoms",
    "Nom",
    "Diplôme",
    "Année d\'obtention",
    "Matricule",
    "Certificat",
    "Institution",
    "Référence",
    "Date de naissance",
];

const DownloadCertificates: React.FC<IProps> = ({certificates}) => {
    const download = () => {
        downloadCertificates(excelHeader, certificates, 'Diplômes');
    }
    return (
        <Button variant="outlined" color="inherit"
            onClick={download}
        >
            <DownloadIcon  />
        </Button>
    )
}

export default DownloadCertificates;